import { render, staticRenderFns } from "./LeftBox.vue?vue&type=template&id=5d06a792&scoped=true&"
import script from "./LeftBox.vue?vue&type=script&lang=js&"
export * from "./LeftBox.vue?vue&type=script&lang=js&"
import style0 from "./LeftBox.vue?vue&type=style&index=0&id=5d06a792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06a792",
  null
  
)

export default component.exports